import { c as _c } from "react/compiler-runtime";
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import Content from './content';
import Group from './group';
import GroupTitle from './group-title';
import Item from './item';
import RadioGroup from './radio-group';
import SubContent from './sub-content';
import SubTrigger from './sub-trigger';
import Trigger from './trigger';
const Divider = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <RadixDropdown.Separator className="w-full h-[1px] bg-(--border-color-tertiary)" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const Dropdown = {
  Portal: RadixDropdown.Portal,
  Root: RadixDropdown.Root,
  Trigger,
  Content,
  Group,
  GroupTitle,
  Divider,
  RadioGroup,
  ItemIndicator: RadixDropdown.ItemIndicator,
  Item,
  Sub: RadixDropdown.Sub,
  SubTrigger,
  SubContent
};
export default Dropdown;